import React from 'react';
import { Button, Container } from 'reactstrap';
import Loader from '../../components/Loader';
import Text from '../../components/Text';
import FormValidator from '../../utils/FormValidator';
import LeadsError from './Leads.error';

import styles from './Leads.styles.module.scss';

const generateValidateFormBeforeProceeding = (props) => () => {
  const {
    formData,
    onNext,
    validationConfig,
    onFormValidated,
  } = props;
  const validator = new FormValidator(validationConfig);
  const result = validator.validate(formData);
  onFormValidated(result);
  if (result.isInvalid) return;
  onNext();
};

export default function LeadsView(props) {
  const {
    children,
    error,
    loading,
    onBack,
    activeButtonText,
    currentStep,
    totalStepCount,
  } = props;
  if (loading) return <Loader />;

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h3>
          <Text value="Additional Information" />
        </h3>
      </div>
      <div className="form-group-wrapper">
        <Container>
          { children }
          <LeadsError error={error} />
          {
            currentStep >= 1 && (
              <div className={styles.progress}>
                Step&nbsp;
                { currentStep }
                &nbsp;of&nbsp;
                { totalStepCount }
              </div>
            )
          }
          <div className={styles.buttons}>
            {
              currentStep > 1 && (
                <Button
                  onClick={onBack}
                >
                  <Text value="Back" />
                </Button>
              )
            }
            <Button
              className={styles.active}
              onClick={generateValidateFormBeforeProceeding(props)}
            >
              <Text value={activeButtonText} />
            </Button>
          </div>
        </Container>
      </div>
    </div>
  );
}
